"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\t", "\n"], ["\n\tposition: relative;\n\t", "\n"])), function (props) { return props.theme.thumbnail.container; });
var Image = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.thumbnail.image; });
var Icon = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", "\n\t", "\n\t", "\n"], ["\n\t", "\n\t",
    "\n\t",
    "\n"])), function (props) { return props.theme.thumbnail.icon; }, function (props) { return props.filtered && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t& svg>path {\n\t\t\tcolor: tomato;\n\t\t\tfill: tomato;\n\t\t}\n\t"], ["\n\t\t& svg>path {\n\t\t\tcolor: tomato;\n\t\t\tfill: tomato;\n\t\t}\n\t"]))); }, function (props) { return props.errored && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t& svg>path {\n\t\t\tcolor: magenta;\n\t\t\tfill: magenta;\n\t\t}\n\t"], ["\n\t\t& svg>path {\n\t\t\tcolor: magenta;\n\t\t\tfill: magenta;\n\t\t}\n\t"]))); });
var Label = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.thumbnail.label; });
var Centered = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 10%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n"], ["\n\tposition: absolute;\n\tbottom: 10%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n"])));
var Debug = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tborder-radius: 10px;\n\tbackground: red;\n\t", "\n\t", "\n\tcolor: ", ";\n\tfont-size: 10px;\n\tpadding: 2px 5px;\n\ttext-align: center;\n\tuser-select: text;\n\tpointer-events: all;\n"], ["\n\tborder-radius: 10px;\n\tbackground: red;\n\t",
    "\n\t",
    "\n\tcolor: ", ";\n\tfont-size: 10px;\n\tpadding: 2px 5px;\n\ttext-align: center;\n\tuser-select: text;\n\tpointer-events: all;\n"])), function (props) { return props.blui && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\tbackground: ", ";\n\t"], ["\n\t\tbackground: ", ";\n\t"])), props.bl3d ? "linear-gradient(to right, grey 50%, black 50% 100%)" : "grey"); }, function (props) { return props.bl3d && styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\tbackground: ", ";\n\t"], ["\n\t\tbackground: ", ";\n\t"])), props.blui ? "linear-gradient(to right, grey 50%, black 50% 100%)" : "black"); }, function (props) { return props.renderable !== false ? "white" : "rgba(255,255,255,0.6)"; });
var Thumbnail = /** @class */ (function (_super) {
    __extends(Thumbnail, _super);
    function Thumbnail(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoad = function () {
            var img = _this.imgRef.current;
            if (img && process.env.REACT_APP_FILTER_PLACEHOLDER_THUMBNAILS === "true") {
                if (img.naturalWidth <= 355 && img.naturalHeight <= 355) {
                    console.warn("Filtering image due to resolution:" + img.src, { width: img.naturalWidth, height: img.naturalHeight });
                    _this.setState({ contentBlank: img.src });
                } /*
                else {
                    console.log(img.src, {width: img.naturalWidth, height: img.naturalHeight})
                }*/
            }
        };
        _this.onError = function () {
            var img = _this.imgRef.current;
            if (img) {
                console.error("Error loading image: " + img.src);
                _this.setState({ contentError: img.src });
            }
        };
        _this.copyToClipboard = function () {
            if (_this.props.id) {
                if (navigator.clipboard) {
                    try {
                        navigator.clipboard.writeText(_this.props.id);
                    }
                    catch (_a) {
                        console.error("No permissions to write to the clipboard");
                    }
                }
            }
        };
        _this.imgRef = react_1.default.createRef();
        _this.state = {
            contentBlank: undefined,
            contentError: undefined
        };
        return _this;
    }
    Thumbnail.prototype.render = function () {
        var _a;
        var content = this.props.content;
        var fallback = false;
        var reason = undefined;
        var filtered = (typeof this.props.content === "string") && (this.state.contentBlank === this.props.content || this.state.contentBlank === encodeURI(this.props.content));
        var errored = (typeof this.props.content === "string") && (this.state.contentError === this.props.content || this.state.contentError === encodeURI(this.props.content));
        if (!content || filtered || errored) {
            fallback = true;
            content = this.props.fallbackContent;
        }
        var debug = window.zlurlparams && window.zlurlparams.debug;
        if (debug) {
            if (filtered) {
                reason = "Image filtered because the resolution (<=355px) suggests its a placeholder\n" + this.state.contentBlank;
            }
            else if (errored) {
                reason = "Image failed to load\n" + this.state.contentError;
            }
        }
        return (react_1.default.createElement(Container, { className: this.props.className },
            (typeof content === "string") ?
                react_1.default.createElement(Image, { src: content, alt: "", highlighted: this.props.highlighted, ref: this.imgRef, onLoad: this.onLoad, onError: this.onError })
                :
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Icon, { fallback: fallback, paint: this.props.paint, filtered: debug && filtered, errored: debug && errored, title: reason }, content),
                        this.props.noPreviewMsg && fallback &&
                            react_1.default.createElement(Label, null, this.props.noPreviewMsg)),
            this.props.id && debug &&
                react_1.default.createElement(Centered, null,
                    react_1.default.createElement(Debug, { renderable: this.props.renderable, bl3d: this.props.bl3d, blui: this.props.blui, onDoubleClick: this.copyToClipboard, title: (_a = this.props.category) === null || _a === void 0 ? void 0 : _a.join("\n") },
                        this.props.id && react_1.default.createElement("span", { style: { display: "block" } }, this.props.id),
                        this.props.validFrom && react_1.default.createElement("span", { style: { display: "block" } }, "DVF: " + this.props.validFrom),
                        this.props.validTo && react_1.default.createElement("span", { style: { display: "block" } }, "DVT: " + this.props.validTo)))));
    };
    return Thumbnail;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Thumbnail);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Thumbnail.js.map